import React from 'react';
import GridWithSidebar from 'components/consumer/GridWithSidebar';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import MasonryPhotoCardsAlgoliaNext from 'components/consumer/inspiration-photos-grid/components/MasonryPhotoCardsAlgoliaNext';
import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';

const DEFAULT_TABS_CONFIG = {
  products: true,
  productsTitle: ' ',
  productsHideLoadMore: true,
};

const CustomerPhotosAlgoliaNext = React.memo(
  ({ getCustomProps, hoveredValue, toggleReviewOnHover }) => {
    const { items, showMore, isLastPage } = useInfiniteHits();
    const { status } = useInstantSearch();

    const hasNoResults = (!items || items.length === 0) && status === 'idle';

    if (hasNoResults) {
      return (
        <div role="status" aria-live="polite" className="py-8 text-center">
          No results found.
        </div>
      );
    }

    return (
      <div>
        <div className="[&_.infinite-scroll-component]:flex [&_.infinite-scroll-component]:flex-row [&_.infinite-scroll-component]:items-start [&_.infinite-scroll-component]:flex-wrap [&_.infinite-scroll-component]:justify-between [&_.infinite-scroll-component]:min-w-full max-[767px]:[&_.infinite-scroll-component]:!mx-0">
          <SuspenseWithLoader fallback={<ProductCardStaticPlaceholder />}>
            <GridWithSidebar
              loading={!items || items.length === 0}
              getCustomProps={getCustomProps}
              gridItemType="customer-photo"
              mobileItemsPerRow={1}
              naturalHeightImages
              renderGrid={({
                selectedGridItem,
                updateSelectedGridItem,
                showOnTop = false,
              }) => (
                <MasonryPhotoCardsAlgoliaNext
                  hits={items}
                  searchMore={showMore}
                  hasMore={!isLastPage}
                  hoveredValue={hoveredValue}
                  onHoverHandler={toggleReviewOnHover}
                  selectedGridItem={selectedGridItem}
                  showModalOnClick
                  showOnTop={showOnTop}
                  isSidebarOpen={showOnTop}
                  updateSelectedGridItem={updateSelectedGridItem}
                />
              )}
              tabsConfig={DEFAULT_TABS_CONFIG}
              variant="InspirationPage"
            />
          </SuspenseWithLoader>
        </div>
      </div>
    );
  }
);

export default CustomerPhotosAlgoliaNext;
